import React from 'react';
import "./QuestionBank.css";
import Quiz2 from "react-quiz-component";
import Sidebar from "../../Component/Dashboard/StudentDashboard/Sidebar/SideBar";

const quiz = {
  quizTitle: "ABC School Class 5 Quiz",
  quizSynopsis: "Answer the following questions to test your React knowledge.",
  questions: [
    {
      question: "What is React?",
      questionType: "text",
      answerSelectionType: "single",
      answers: [
        "A programming language",
        "A JavaScript library",
        "A database",
        "An operating system ",
      ],
      correctAnswer: "2",
      messageForCorrectAnswer: "Correct! React is a JavaScript library.",
      messageForIncorrectAnswer: "Wrong! React is a JavaScript library.",
    },
    {
      question: "Which company maintains React?",
      questionType: "text",
      answerSelectionType: "single",
      answers: ["Google", "Facebook", "Microsoft", "Twitter"],
      correctAnswer: "2",
      messageForCorrectAnswer: "Correct! React is maintained by Facebook.",
      messageForIncorrectAnswer: "Wrong! React is maintained by Facebook.",
    },
    {
      question: "What is a component in React?",
      questionType: "text",
      answerSelectionType: "single",
      answers: [
        "A function or class that renders UI",
        "A database entity",
        "An external script",
        "A CSS framework",
      ],
      correctAnswer: "1",
      messageForCorrectAnswer: "Correct! A component renders UI in React.",
      messageForIncorrectAnswer: "Wrong! A component renders UI in React.",
    },
  ],
  appLocale: {
    landingHeaderText: "Welcome to the React Quiz!",
    question: "Question",
    startQuizBtn: "Start Quiz",
    resultPageHeaderText: "You have completed the quiz!",
    resultFilterAll: "All",
    resultFilterCorrect: "Correct",
    resultFilterIncorrect: "Incorrect",
    nextQuestionBtn: "Next",
    resultPagePoint: "You scored: <correctPoints> out of <totalPoints>",
  },
};
const QuestionBank = () => {
  return (
    <div class="container-scroller">
      <Sidebar />
      <div class="main-panel">
        <div class="content-wrapper">
          <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
            <h1 style={{ textAlign: "center" }}>Class V Quiz</h1>
            <Quiz2
              quiz={quiz}
              shuffle={true}
              showInstantFeedback={true}
              continueTillCorrect={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionBank;
